<template lang="pug" src="./resources/schedule.pug"></template>

<script>

import WeekSchedule from './WeekSchedule'
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'DaySchedule',
    extends: WeekSchedule,
    computed: {
        ...mapGetters({
            period: 'event/dayPeriod',
        })
    }
}

</script>

<style lang="sass" scoped>
    @import "./resources/schedule"
</style>
